import { Sites, SiteConstants } from '@labradorsports/constants';
import { SportRenderingConfigs } from '@labradorsports/play-rendering';
import SportConfigs from '@labradorsports/sports';

export const Config = SportConfigs[Sites.hoopslab];
export const RenderingConfig = SportRenderingConfigs[Sites.hoopslab];
export const TestUrl = SiteConstants[Sites.hoopslab].TestUrl;
